import { render, staticRenderFns } from "./HorseRide.vue?vue&type=template&id=0ca340e6&scoped=true&lang=html&"
import script from "./HorseRide.vue?vue&type=script&lang=js&"
export * from "./HorseRide.vue?vue&type=script&lang=js&"
import style0 from "./HorseRide.vue?vue&type=style&index=0&id=0ca340e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca340e6",
  null
  
)

export default component.exports